import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useSendReceiptApiV1PaymentsTransactionsTransactionIdSendReceiptPost } from '#/shared/api/generated/billing/theCargoBilling'
import { getApiErrorDetail } from '#/shared/lib/api/error-handler'
import { toast } from '#/shared/ui/sonner'

const PAYMENT_LIST_QUERY_PREFIX = '/api/v1/payments'

export interface SendPaymentReceipt {
  send: (transactionId: string, email?: string) => Promise<void>
  isSending: boolean
}

export function useSendPaymentReceipt(): SendPaymentReceipt {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const mutation =
    useSendReceiptApiV1PaymentsTransactionsTransactionIdSendReceiptPost()

  const send = async (transactionId: string, email?: string) => {
    try {
      await mutation.mutateAsync({
        transactionId,
        data: email ? { to_email: email } : {},
      })
      queryClient.invalidateQueries({ queryKey: [PAYMENT_LIST_QUERY_PREFIX] })
      toast.success(t('orderDetails.comment.payment.toast.sendReceiptSuccess'))
    } catch (err) {
      toast.error(
        getApiErrorDetail(err) ??
          t('orderDetails.comment.payment.toast.sendReceiptError'),
      )
    }
  }

  return { send, isSending: mutation.isPending }
}
